/*  ==============================================
//  Created by tuanBa                          ||
//  create at: 2022-03-15                      ||
//===============================================*/
import { Component, EventEmitter, Injectable, Injector, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, NgForm } from '@angular/forms';
import { UploadService } from '../../../../../common/services/Upload.service';
import { ConfirmationService } from 'primeng/primeng';
import { EvsStoreService } from '../../../../../common/services/EvsStore.service';
import { Location } from '@angular/common';
import { CategoryService } from '../../../../../common/services/Category.service';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { StoreSaleService } from './services/store-sale.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

declare var $: any;
var that;

@Component({
  moduleId: module.id,
  selector: 'app-store-sale-add',
  templateUrl: './store-sale_add.component.html',
  styleUrls: ['../store.css'],
  providers: [ConfirmationService, EvsStoreService, EvsAddressService, StoreSaleService]
})
@Injectable()
export class StoreSaleAddComponent implements OnInit, OnDestroy {
  @Output('backComponent') backComponent = new EventEmitter();
  public store: any = {};
  public message: { class: string, content: string } = null;
  public error: string = '';
  public cities: Array<any> = [];
  public districts: Array<any> = [];
  private langSub: Subscription;

  // listType = [
  //     { id: 1, value: 1, label: 'Điểm bán' },
  //     { id: 2, value: 2, label: 'Bảo hành' },
  //     { id: 3, value: 3, label: 'Điểm bán + Bảo hành' }
  // ];

  /*Ham them anh vao mang*/
  images = [];

  constructor(private injector: Injector,
    private _location: Location,
    private storeService: EvsStoreService,
    public addressService: EvsAddressService,
    private upload: UploadService,
    private cate: CategoryService,
    private _fb: FormBuilder,
    private storeSaleService: StoreSaleService,
    private toastr: ToastrService,
    private translate: TranslateService) {
    that = this;
  }

  getCity() {
    this.addressService.getCities().subscribe(res => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  ngOnInit() {
    this.getCity();
    this.initSelect2();
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.initSelect2();
    });
    this.store.status = 1;
  }

  initSelect2() {
    $('#provinces').select2({ placeholder: '-- ' + this.translate.instant('TINH_THANH_PHO') + ' --', allowClear: false, width: '100%' }).off('select2:select').on('select2:select', function (e) {
      setTimeout(() => {
        $('.select2-selection__rendered').removeAttr('title');
        var id = e.target.value;
        that.loadDistrictData(id);
      }, 100)

    });
    $('#districts').select2({ placeholder: '-- ' + this.translate.instant('QUAN_HUYEN_LABEL') + ' --', allowClear: false, width: '100%' })
      .off('select2:select').on('select2:select', function (e) {
        $('.select2-selection__rendered').removeAttr('title');
      });
  }

  ngOnDestroy() {
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  telephoneCheck(str) {
    if (str === null || str === undefined || str.length === 0) {
      return true
    }
    var patt = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);
    return patt.test(str);
  }

  loadDistrictData(id: number) {
    this.addressService.getDistrict({ city_id: id }).toPromise().then(res => {
      let districts = [];
      res.data.districts.forEach((c: any) => {
        districts.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.districts = districts;
    })
  }

  resetForm(frm: NgForm) {
    frm.resetForm();
    // $('#name').val('');
    // $('#code').val('');
    // $('#type').val('').trigger('change');
    $('#address').val('');
    $('#provinces').val('').trigger('change');
    $('#districts').val('').trigger('change');
    this.store.status = 1;
    this.store.name = '';
    this.store.code = '';
  }

  backToComponent() {
    this.backComponent.emit({
      isBack: true
    });
    //this._location.back();
  }

  onSubmit(form: NgForm) {
    let image;
    if (this.images.length == 1) {
      image = this.images[0].url
    } else {
      image = ''
    }
    this.message = null;
    let objectData = {};
    let province = $('#provinces option:selected').val();
    let district = $('#districts option:selected').val();
    if (this.store.name.trim().length === 0) {
      this.message = { class: 'alert alert-danger', content: 'Tên không được bỏ trống !' };
    } else if (!province) {
      this.message = { class: 'alert alert-danger', content: 'Bạn chưa chọn Tỉnh/TP !' };
    } else if (!district) {
      this.message = { class: 'alert alert-danger', content: 'Bạn chưa chọn Quận/Huyện !' };
    } else if (!this.telephoneCheck(this.store.phone)) {
      this.message = { class: 'alert alert-danger', content: 'Sai định dạng số điện thoại' };
    } else if (this.store.address.trim().length === 0) {
      this.message = { class: 'alert alert-danger', content: 'Địa chỉ không được bỏ trống !' };
    } else {
      this.processSave();
      this.store.province = $('#provinces option:selected').text();
      this.store.district = $('#districts option:selected').text();
      objectData = {
        'name': this.store.name,
        'address': this.store.address,
        'provinceId': province,
        'districtId': district,
        'phone': this.store.phone,
        'status': this.store.status,
        'image': image
      };
      this.storeSaleService.addNewStoreSale(objectData).subscribe(res => {
        if (res) {
          let error = res.error;
          if (error) {
            this.toastr.error('Thêm mới thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          } else {
            this.resetForm(form);
            this.toastr.success('Thêm mới thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
            this.backComponent.emit({
              isBack: false
            });
          }
        }
      }, error => {
        this.message = { class: 'alert dark alert-danger', content: error.message };
      });
    }
    this.images = []
    this.scrollToTop();
  }

  processSave() {
    this.message = {
      class: 'alert dark alert-info',
      content: 'Đang thực thi...'
    };
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  tusUpload = (item) => {
    const numberImages = item.target.files.length;
    console.log('numberImages', numberImages)
    if (numberImages > 2) {
      this.toastr.error('Chỉ được upload tối đa 1 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {
        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = {
              id: res.data.fileId,
              url: res.data.url,
            };
            if (this.images.length >= 1) {
              console.log(123123)
              this.toastr.error('Chỉ được upload tối đa 1 ảnh', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              console.log(3412356)
              this.images.push(image2);
            }
          }
        });

      }
    }
  };

  deleteImage(id) {
    for (let i = 0; i < this.images.length; i++) {
      if (this.images[i].id === id) {
        this.images.splice(this.images.indexOf(this.images[i]), 1);
        break;
      }
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/store_manager/store-sale/store-sale_add.component.ts